import React from 'react';

import { ResourceIdDto } from '@/api/generated';
import { ResourceTimelineMessagesTable } from '@/components/timelineMessages/comp/ResourceTimelineMessagesTable.comp.tsx';
import { useTranslationWithPrefix } from '@/utils/useTranslationWithPrefix';
import { CustomerDetailsAccordion } from '@/views/customerDetails/components/CustomerDetailsAccordion.comp.tsx';

type Props = {
  resource: ResourceIdDto;
};

export const ResourceDetailsTimelineMessages: React.FC<Props> = ({ resource }) => {
  const { t } = useTranslationWithPrefix('components.timelineMessages');

  return (
    <CustomerDetailsAccordion expanded title={t('title')}>
      <ResourceTimelineMessagesTable resource={resource} />
    </CustomerDetailsAccordion>
  );
};
